import { BaseConfig } from '../ServiceConfig';

export interface ImageConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.ImageServiceConfigData';
  url: string;
}

export const ImageConfigurationFields: (keyof ImageConfiguration)[] = ['url'];

export const BlankImageConfiguration: ImageConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.ImageServiceConfigData',
} as ImageConfiguration;
